( function( $, window, document, undefined ) {

	$( document ).ready(function() {
		$('.c-filter .form__checkbox').click(function(){
			$('#topics-filter').submit();
		});
	});

})( jQuery, window, document );
